import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import Box from "@mui/material/Box";
import { useCallback, useState } from "react";
import ConfigureControlWrapper from "../configureControl/ConfigureControlWrapper";

export function ConfigureSources({
  hash,
  hashBySource,
  onHashChange,
  sport,
  sources,
}) {
  const [value, setValue] = useState("0");

  const handleChange = useCallback((event, newValue) => {
    setValue(newValue);
  }, []);

  return (
    <Box sx={{ background: '#f9f9f9', overflow: 'auto', width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            centered
          >
            {sources && !!sources.length && sources.map((item, index) => (
              <Tab key={item.id} label={item.name} value={index.toString()} />
            ))}
          </TabList>
        </Box>
        {!!Object.values(hashBySource).length && sources.map((source, index) => <TabPanel key={index} value={index.toString()}>
          <ConfigureControlWrapper
            key={source}
            hash={hash}
            hashBySource={hashBySource[source.id]}
            onHashChange={onHashChange}
            sport={sport}
            sources={sources}
          />
        </TabPanel>)}
      </TabContext>
    </Box>
  );
}
